export const Colors = {
  primary: "#F0590E",
  primaryHover: "#D94D0A",
  primaryLight: "#FEF0E1",
  primaryForeground: "#FFFFFF",
  accent: "#2D6A4F",
  accentLight: "#E8F5EE",
  dark: "#171717",
  dark2: "#3F3F3F",
  grayDark: "#6B7280",
  grayMedium: "#929292",
  grayLight: "#F5F5F5",
  background: "#F9FAFB",
  border: "#E5E7EB",
  danger: "#EB4335",
  success: "#27AE60",
  warning: "#F59E0B",
  blue: "#538ECA",
};

// Dashboard theme constants (unified with design system)
export const dashboardColors = {
  primary: Colors.primary,
  primaryHover: Colors.primaryHover,
  accent: Colors.accent,
  accentLight: Colors.accentLight,
  textPrimary: Colors.dark,
  textSecondary: Colors.grayDark,
  bgMain: Colors.background,
  bgCard: "#FFFFFF",
  success: Colors.success,
  warning: Colors.warning,
  danger: Colors.danger,
  neutral: Colors.grayMedium,
  border: Colors.border,
  chartPrimary: Colors.primary,
  chartSecondary: Colors.accent,
  chartTertiary: Colors.warning,
  chartQuaternary: Colors.blue,
};

export const dashboardSpacing = {
  cardGap: "24px",
  cardPadding: "24px",
  sectionGap: "32px",
  cardInnerSpacing: "16px",
};

export const dashboardTypography = {
  cardTitle: "16px",
  mainMetric: "28px",
  label: "14px",
  small: "12px",
};

export const dashboardShadows = {
  card: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  cardHover: "0 4px 12px rgba(0,0,0,0.08)",
};

export const chartColorPalette = [
  dashboardColors.chartPrimary,
  dashboardColors.chartSecondary,
  dashboardColors.chartTertiary,
  dashboardColors.chartQuaternary,
  "#8B5CF6",
  "#EC4899",
  "#06B6D4",
  "#84CC16",
];
